import { ScreenHeader } from "@/components/ui/ScreenHeader";
import { Stack } from "expo-router";

export default function RegisterScreenLayout() {
  return (
    <Stack
      screenOptions={{
        headerShown: true,
        header: (props) => <ScreenHeader title="auth.register.headerTitle" {...props} />,
      }}
    />
  );
}
